import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fetch_commission} from "../../redux/actions";
import {withRouter} from "react-router-dom";
import CommissionDamagesComponent from "./CommissionDamagesComponent";

class CommissionDamagesContainer extends Component {
    componentDidMount() {
        if (!this.props.current_commission.id) {
            this.props.fetch_commission(this.props.match.params.commissionId);
        } else {
            this.props.fetch_commission(this.props.current_commission.id);
        }
    }


    render() {
        let currentCommission = this.props.current_commission;

        if (!currentCommission.commissionName) {
            return <div>Loading</div>;
        }

        return (
            <CommissionDamagesComponent commissionName={currentCommission.commissionName}
                                        commissionStatus={currentCommission.status}
                                        correctiveEvents={currentCommission.correctiveEvents}
                                        classPeriodTradingStats={currentCommission.classPeriodTradingStats}
                                        marketCapitalizationLosses={currentCommission.marketCapitalizationLosses}
                                        statResidualReturns={currentCommission.statResidualReturns}
                                        stockPrices={currentCommission.stockPrices}
                                        dollarValueInflations={currentCommission.dollarValueInflations}
                                        aggregateDamages={currentCommission.aggregateDamages}
                                        ticker={currentCommission.symbol}
                                        dateCommissioned={currentCommission.dateCommissioned}
                                        lastUpdate={currentCommission.lastUpdate}
                                        classPeriodStart={currentCommission.classPeriodStart}
                                        classPeriodEnd={currentCommission.classPeriodEnd}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        current_commission: state.commissions.selected_commission
    }
};

const mapDispatchToProps = dispatch => {
    return {
        fetch_commission: (page) => dispatch(fetch_commission(page))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CommissionDamagesContainer));


// WEBPACK FOOTER //
// ./src/commissions/components/damages/CommissionDamagesContainer.js